const state = {
  referrer: ''
}

const getters = {
  getReferrer: state => state.referrer

}

const mutations = {
  SET_REFERRER (state, payload) {
    state.referrer = payload
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters
}
